var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h4", { staticClass: "border-bottom pb-05 mb-1" }, [
        _vm._v(_vm._s(_vm.__("group.title_invite"))),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.__("group.paragraphs.invite_contacts")))]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.search_term,
            expression: "search_term",
          },
        ],
        staticClass: "form-control round",
        attrs: {
          type: "text",
          name: "search_term",
          id: "search_term",
          placeholder: _vm.__("group.form.placeholder.search"),
        },
        domProps: { value: _vm.search_term },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.search_term = $event.target.value
            },
            _vm.debounceInput,
          ],
        },
      }),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "list-supplier m-1 p-0" },
        _vm._l(_vm.friends, function (friend, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass:
                "list-supplier-item d-flex justify-content-between align-items-center mt-05",
              staticStyle: { "list-style-type": "none" },
            },
            [
              _c("user-invite-card", {
                attrs: { user: friend, type: _vm.type, slug: _vm.slug },
              }),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "infinite-loading",
        {
          attrs: { identifier: _vm.infiniteId },
          on: {
            distance: function ($event) {
              1
            },
            infinite: _vm.infiniteHandler,
          },
        },
        [
          _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "no-results" }, slot: "no-results" }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }